import axios from "axios";
import { requestLoginSuccess } from "../utils/auth";
import { showLoginError, showLoginSuccess } from "../utils/bootstrapUI";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { getUser } from "../utils/API";

const useLoginWithSocial = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false)
  const [successLogin, setSuccessLogin] = useState(false)

  const loginWithGoogle = async (tokenGoogle, email) => {
    if (email) {
      dispatch({ type: 'SET_SUBMITTED_EMAIL', value: email });
    }
    setIsLoading(true)

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_ADMS_AUTH}/v1/auth/login`, {
        authToken: tokenGoogle,
        channel: 'google'
      });

      if (res.data.status !== 1) {
        throw res
      }

      requestLoginSuccess(res.data.data)
      setSuccessLogin(true)
      showLoginSuccess()

      getUser(res.data.data.login.UserId).then((userInfo) => {
        dispatch({ type: 'SET_SUBMITTED_EMAIL', value: userInfo.data.users.Email });
      })

      window.location.href = '/'

      return res.data.data
    } catch (error) {
      showLoginError(error.response ? error.response.data.message : error.data.message)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    loginWithGoogle,
    isSuccess: successLogin
  }
}

export default useLoginWithSocial;